<template>
  <div class="salesforce-env-switch">
    <div class="salesforce-env-switch__header">
      <span>Salesforce Environment</span>
      <span
        class="salesforce-env-switch__header__hide"
        @click="$emit('hideButtonClick')"
      >
        hide
      </span>
    </div>
    <select
      v-model="salesforceEnv"
      @input="updateFactoryByEnv"
    >
      <option
        v-for="option in envOptions"
        :key="option"
        :value="option"
      >
        {{ option }}
      </option>
    </select>
  </div>
</template>

<script>
import { billingAutomationClient } from '@/shared/utils/clients/billingAutomationClient';

export default {
  name: 'SalesforceEnvSwitch',
  data() {
    return {
      salesforceEnv: null,
    };
  },
  computed: {
    envOptions() {
      return ['integneo', 'dev05'];
    },
  },
  async mounted() {
    this.salesforceEnv = billingAutomationClient.getEnv();
  },
  methods: {
    updateFactoryByEnv(event) {
      billingAutomationClient.updateFactoryByEnv(event.target.value);
    },
  },
};
</script>

<style lang="scss">
.salesforce-env-switch{
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: #fff;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 5px;
  z-index: 1000;
  display: flex;
  gap: 8px;
  flex-direction: column;
}

.salesforce-env-switch__header {
  display: flex;
  gap: 8px;
}

.salesforce-env-switch__header__hide {
  cursor: pointer;
  color: #007bff;
  text-decoration: underline;
}
</style>
